module.exports = __webpack_public_path__ + "static/media/20-3.1428e82f.mp3";